module.exports = __webpack_public_path__ + "assets/img/b7311b04fa385dbe6d8dd8f3648178f7.png";